import React from 'react';
import styles from './ProtessItems.module.scss';

export const ProgressItems = ({ items }) => {
  return (
    <>
      <div className={styles.progressItemsWrapper}>
        {items.map((item) => (
          <div key={item.description} className={styles.progressItemWrapper}>
            <div className={styles.iconAndValueWrapper}>
              <img src={item.imageSrc} alt="Boomer books read" />
              <p>{item.value}</p>
            </div>
            <div className={styles.description}>{item.description}</div>
          </div>
        ))}
      </div>
    </>
  );
};
